export default context => {
    const refs = {
        bodyElm: document.body,
        select: context.querySelector('select'),
        get options() {
            return this.select.querySelectorAll('option');
        },
        get visibleOptions() {
            return [...this.options].filter(option => option.style.display !== 'none');
        }
    };

    const NODE_CLASS_NAME = 'input-select';

    const displayModes = ['floating', 'inline'];

    const initialSelectedIndex = refs.select.selectedIndex;

    let currentState = 'optionsClosed';

    function setState(state) {
        switch (state) {
            case 'optionsOpened':
                refs.bodyElm.classList.add('input-select-options-opened');
                context.classList.add('options-opened');
                currentState = 'optionsOpened';
                break;

            case 'optionsClosed':
                refs.bodyElm.classList.remove('input-select-options-opened');
                context.classList.remove('options-opened');
                currentState = 'optionsClosed';
                break;

            default:
                break;
        }
    }

    function getSelectedValue() {
        return refs.options[refs.select.selectedIndex].value;
    }

    if (getSelectedValue().length) {
        context.classList.add('has-selection');
    }

    function toggleOptions(e) {
        e.stopPropagation();
        if (currentState === 'optionsClosed') {
            setState('optionsOpened');
        } else {
            setState('optionsClosed');
        }
    }

    function isOnDisplayMode(modifier) {
        return context.classList.contains(`${NODE_CLASS_NAME}--${modifier}`);
    }

    function setDisplayMode(modifier) {
        if (displayModes.indexOf(modifier) >= 0 && !isOnDisplayMode(modifier)) {
            displayModes.forEach(x => context.classList.remove(`${NODE_CLASS_NAME}--${x}`));

            context.classList.add(`${NODE_CLASS_NAME}--${modifier}`);
        }
    }

    function populate(options, optionCategories) {
        clear();

        if (typeof options !== 'undefined') {
            options.forEach(optionData => refs.select.add(createOptionNode(optionData)));
        }

        if (typeof optionCategories !== 'undefined') {
            optionCategories.forEach(optionCategoryData => {
                refs.select.appendChild(createOptionCategoryNode(optionCategoryData));
            });
        }

        toggleHasSelection(hasValue());
    }

    function createOptionCategoryNode(optionCategoryData) {
        const optgroupNode = document.createElement('optgroup');

        optgroupNode.label = optionCategoryData.label;

        optionCategoryData.options.forEach(optionData => optgroupNode.appendChild(createOptionNode(optionData)));

        return optgroupNode;
    }

    function createOptionNode(optionData) {
        const optionElement = document.createElement('option');

        optionElement.value = optionData.name;
        optionElement.selected = optionData.selected || false;
        let innerText = optionData.label;

        if (typeof optionData.count !== 'undefined') {
            const formattedCount = optionData.count.toLocaleString('nl-NL');

            innerText += ` (${formattedCount})`;
        }

        optionElement.innerText = innerText;

        return optionElement;
    }

    function toggleHasSelection(toggle) {
        if (toggle) {
            context.classList.add('has-selection');
        } else {
            context.classList.remove('has-selection');
        }
    }

    function hasEmptyOption() {
        return !!refs.select.options[0].value;
    }

    function hasValue() {
        const selectedOption = refs.select.options[refs.select.selectedIndex].cloneNode(true);
        const hasSelectedOption =
            (refs.select.selectedIndex > 0 && typeof selectedOption !== 'undefined') ||
            (refs.select.selectedIndex === 0 && refs.select.options[0].value.length > 0);

        return hasSelectedOption;
    }

    function clear() {
        const firstOption = refs.select.options[0].cloneNode(true);

        refs.select.innerHTML = '';

        if (!firstOption.value) {
            refs.select.appendChild(firstOption);
        }
    }

    function reset() {
        if (hasEmptyOption()) {
            refs.select.selectedIndex = initialSelectedIndex;
        } else {
            refs.select.selectedIndex = 0;
        }
        toggleHasSelection(hasValue());
    }

    function enable() {
        refs.select.disabled = false;
        context.classList.remove('disabled');
    }

    function disable() {
        context.classList.add('disabled');
        refs.select.disabled = true;
        reset();
    }

    function firstItemIsSelected() {
        const firstItem = refs.visibleOptions[1];

        return typeof firstItem !== 'undefined' && firstItem.selected === true;
    }

    function lastItemIsSelected() {
        const lastItem = refs.visibleOptions[refs.visibleOptions.length - 1];

        return typeof lastItem !== 'undefined' && lastItem.selected === true;
    }

    refs.select.addEventListener('click', toggleOptions);

    refs.select.addEventListener('change', () => {
        refs.select.removeEventListener('click', toggleOptions);

        const selectedValue = getSelectedValue();

        if (selectedValue === '') {
            context.classList.remove('has-selection');
        } else {
            context.classList.add('has-selection');
        }

        setState('optionsClosed');

        setTimeout(() => {
            refs.select.addEventListener('click', toggleOptions);
        }, 500);
    });

    refs.select.addEventListener('blur', () => setState('optionsClosed'));

    refs.select.addEventListener('keydown', e => {
        if (e.keyCode === 32 || e.keyCode === 13) {
            setState('optionsOpened');
        }
    });

    return {
        reset,
        enable,
        disable,
        clear,
        populate,
        hasValue,
        firstItemIsSelected,
        lastItemIsSelected,
        setDisplayMode,
        isOnDisplayMode
    };
};
